<template>
  <div class="empty">
    <el-image style="width: 345px; height: 160px" :src="emptyImg" fit="cover"></el-image>
  </div>
</template>

<script>
  import emptyImg from '@/assets/img/policy/empty.png';
  export default {
    name: "Empty",
    data() {
      return {
        emptyImg
      }
    }
  }
</script>

<style scoped>
  .empty {
    min-height: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
